<template>
    <div id="content" :class="{active: this.menuClose}">
      <Navbar @menuClick="menuClicked" />
      <router-view />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'nonav-layout',
  data () {
    return {
      menuClose: false
    }
  },
  components: {
    Navbar
  },
  methods: {
    menuClicked () {
      console.log('menu clicked')
      this.menuClose = !this.menuClose
    },
    dismissClicked () {
      this.menuClose = !this.menuClose
    }
  }
}
</script>
